Directives.QuickbooksIntegrationDirective = function QuickbooksIntegrationDirective()  {

    "use strict";

    // @ngInject
    function QuickbooksIntegrationDirectiveControllerCtor($scope, $injector, intuit,
                                                     Gon, Routes, AnalyticsService, moment, _, PopupMessageService,
                                                     UsersManager, CompaniesManager, UrlMetadataService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'QuickbooksIntegrationDirectiveController';

        this.intuit = intuit;
        this.moment = moment;
        this.AnalyticsService = AnalyticsService;
        this.CompaniesManager = CompaniesManager;
        this.PopupMessageService = PopupMessageService;
        this._ = _;
        this.UsersManager = UsersManager;
        this.user = UsersManager.getCurrUser();
        this.company = CompaniesManager.getCurrCompany();

        this.isLoadingQuickbooks = true;
        this.isConnectedToQuickbooks = false;
        this.taxCodeNames = {};
        this.depositAccountsNames = {};

        if (this.company.wasFullyFetched()) {
            this.gotCompany();
        }

        // Support for old layout
        this.shouldShowFaq = this.isOldStyle;

        this.register(this.company, 'success', this.gotCompany);

        // Fix url for local
        var grantUrl = Gon.url + Routes.v2_quickbooks_oauth2_authenticate_path();
        grantUrl = grantUrl.replace(/\/{2,}/g,'/').replace(/(https?:)\//, "$1//");
        grantUrl = UrlMetadataService.addMetadata(grantUrl);

        this.intuit.then(function(intuitSdk) {
            intuitSdk.ipp.anywhere.setup({
                grantUrl: grantUrl,
                dataSources: {
                    quickbooks: true,
                    payments: true
                }
            });
        });

    }


    var QuickbooksIntegrationDirectiveController = Class(Controllers.BaseController, {

        constructor: QuickbooksIntegrationDirectiveControllerCtor,

        connectToQB: function connectToQB() {
            this.intuit.then(function(intuitSdk) {
                intuitSdk.ipp.anywhere.controller.onConnectToIntuitClicked();
            });
        },

        gotCompany: function gotCompany() {
            this.isConnectedToQuickbooks = this.company.quickbooks_integration && this.company.quickbooks_integration.connected_at;
            this.isLoadingQuickbooks = false;
            if (this.isConnectedToQuickbooks) {
                this.connectedSince = this.moment(this.company.quickbooks_integration.connected_at).fromNow();

                this.showTaxCodeLoader = true;
                this.CompaniesManager.getQuickbooksTaxCode(this.company)
                    .then(function gotTaxCodes(res) {
                            this.qbTaxCodes = res.data.available_codes.filter(function filterTaxCodes(taxCode) {
                                var res = taxCode.is_active === true;
                                if (res) {
                                    this.taxCodeNames[taxCode.id] = taxCode.name;
                                }
                                return res;
                            }.bind(this));

                            this.selectedTaxCode = res.data.selected_tax_code || '';
                        }.bind(this)
                    )
                    .finally(function getQuickbooksTaxCodeFinally() {
                        this.showTaxCodeLoader = false;
                    }.bind(this));

                this.updateDepositAccountInProgress = true;
                this.CompaniesManager.getQuickbooksDepositAccounts(this.company)
                    .then(function getDepositableAccounts(res) {
                        this.depositableAccounts = res.data.available_accounts;
                        this._.each(this.depositableAccounts, function(account) {
                            this.depositAccountsNames[account.id] = account.name;
                        }.bind(this));

                        this.depositAccountId = res.data.account_for_deposit || '';
                    }.bind(this))
                    .finally(function final() {
                        this.updateDepositAccountInProgress = false;
                    }.bind(this));
            }
        },

        onDepositAccountChange: function onDepositAccountChange() {

            if (this.updateDepositAccountInProgress) {
                return;
            }

            var accountName = this.depositAccountsNames[this.depositAccountId];

            this.updateDepositAccountInProgress = true;
            this.AnalyticsService.track(this, 'quickbooks deposit account change', {depositAccountId: this.depositAccountId, depositAccountName: accountName});

            this.CompaniesManager.updateQuickbooksDepositAccount(this.company, this.depositAccountId)
                .catch(function error() {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._TRY_AGAIN_');
                }.bind(this))
                .finally(function final() {
                    this.updateDepositAccountInProgress = false;
                }.bind(this));
        },

        onQuickbooksConnected: function onQuickbooksConnected() {
            this.AnalyticsService.trackSuccess(this, 'connect to quickbooks');
            this.CompaniesManager.getCurrCompany(true);
        },

        onQuickbooksDisconnectClick: function onQuickbooksDisconnectClick() {

            if (this.disconnectQuickbooksInProgress) {
                return;
            }

            this.PopupMessageService.showConfirmPromise(this.PopupMessageService.severityTypes.info, 'BANK_INFO.QUICKBOOKS_SETTINGS_INTEGRATION._DISCONNECT_CONFIRM_').then(function disconnect() {
                this.disconnectQuickbooksInProgress = true;
                this.CompaniesManager.disconnectQuickbooks(this.company).finally(function() {
                    this.UsersManager.saveCurrUser();
                    this.disconnectQuickbooksInProgress = false;
                }.bind(this));
            }.bind(this));
        },

        qbTaxChange: function qbTaxChange() {
            this.AnalyticsService.track(this, 'quickbooks tax code change', {newCode: this.selectedTaxCode, newCodeName: this.taxCodeNames[this.selectedTaxCode]});
            this.CompaniesManager.updateQuickbooksTaxCode(this.company, this.selectedTaxCode || null);
        }
    });

    return {
        scope: {
            isOldStyle: '<',
        },
        templateUrl: 'angular/app/modules/core/features/settings/account/quickbooks_integration/quickbooks_integrations_template.html',
        controller: QuickbooksIntegrationDirectiveController,
        controllerAs: 'quickbooksIntegrationVm',
        bindToController: true
    };
};
